import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import urlHandler                       from '../../utils/urlHandler';
import settings                         from '../../utils/settings';
import { PieChart }                     from 'react-minimal-pie-chart';

class KbInfoControl extends Component {
    constructor(props){
        super(props);

        this.colors = ['#7fc349', '#bfe1a4', '#00a2ae', '#f8ad28', '#c95772', '#aa61ad'];

        this.isIE = /*@cc_on!@*/false || !!document.documentMode;
        // Edge 20+
        this.isEdge = !this.isIE && !!window.StyleMedia;
    }

    componentDidMount() {
    }

    render() {    
        var data = [];
        if (this.props.kbs) {
            this.props.kbs.map((item, index) => { 
                data.push({
                    title: item.name, 
                    value: item.recordCount, 
                    color: this.colors[index]
                })
            });
        };

        return (
            <div>
            {this.props.kbs &&
                <div className="kb-info-wrapper">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <PieChart data={data}
                                        label={({ dataEntry }) => dataEntry.title }
                                        labelPosition={110}
                                        radius={42}
                                        labelStyle={{
                                            fontSize: '7px',
                                            fontFamily: 'sans-serif',
                                            fill: '#008A94',
                                        }}
                                        animate={(this.isEdge || this.isIE) ? false : true}
                                        lineWidth={25}
                                        style={{height: '175px', width: '350px'}}>
                                    </PieChart>
                                </td>
                                <td className="kb-info-flex">
                                {this.props.kbs.map((item, key) =>
                                    <span key={item.name} className="kb-info-component">
                                        <div className="title">
                                            {item.name}
                                        </div>
                                        <div className="body">
                                            <div>
                                                <span className="field">Record Count:</span> {item.recordCount.toLocaleString('en')}
                                            </div>
                                            <div>
                                                <span className="field">In Memory Size:</span> {(item.inMemorySize / (1024*1024)).toLocaleString('en', {maximumSignificantDigits: 4})} (Mb)
                                            </div>
                                        </div>
                                    </span>
                                )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
            </div>
        );
    }
}

KbInfoControl.propTypes = {
    kbs: PropTypes.array
};

export default KbInfoControl;
